import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactFormInfo from "./sections/ContactFormInfo";
import Map from "./sections/Map";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Hero />
      <ContactFormInfo />
      <Map />
      <Footer />
    </div>;
}